'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _aphrodite = require('aphrodite');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Select Country of Nationality
 * - user's country used to determine add card and add address formats
 */

var STYLES = _aphrodite.StyleSheet.create({
	dropdown: {
		padding: 0,
		textIndent: 10,
		WebkitAppearance: 'none',
		MozAppearance: 'none',
		appearance: 'none',
		'@-moz-document url-prefix()': {
			textIndent: 2.5
		},
		'::-ms-expand': { display: 'none' }
	},

	arrow: {
		position: 'absolute',
		right: 10,
		top: '50%',
		cursor: 'default',
		pointerEvents: 'none'
	}
});

var CountrySelection = _react2.default.createClass({
	displayName: 'CountrySelection',

	propTypes: {
		supportedCountries: function supportedCountries(props, propName, componentName) {
			var supportedCountries = props[propName];

			// if we don't get the array of states we're expecting from Griffin, return an error
			if (!Array.isArray(supportedCountries) || supportedCountries.length && !supportedCountries[0].countryCode) {
				return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Please supply the array you get back from griffin.metadata.allSupportedCountries(), but map each supported country to an object: `{ countryCode, countryName }.`');
			}
			return null;
		},
		defaultValue: _react.PropTypes.string,
		changeCountry: _react.PropTypes.func.isRequired
	},

	getDefaultProps: function getDefaultProps() {
		return {
			supportedCountries: [],
			changeCountry: function changeCountry() {}
		};
	},


	/**
  * Set initial state to the first country in the list
  */
	getInitialState: function getInitialState() {
		return {
			selectedCountry: this.props.defaultValue || this.props.supportedCountries[0].countryCode
		};
	},


	/**
  * Select the first country in the list
  */
	componentDidMount: function componentDidMount() {
		this.props.changeCountry(this.state.selectedCountry);
	},


	/**
  * Handle changing the selected country
  * - set the state
  * - call parent's changeCountry() with the selected country
  */
	handleChangeCountry: function handleChangeCountry(event) {
		var selectedCountry = event.target.value;
		this.setState({ selectedCountry: selectedCountry });
		this.props.changeCountry(selectedCountry);
	},
	render: function render() {

		// don't render anything if we don't get the correctly formatted list of countries
		if (!this.props.supportedCountries[0].countryCode) {
			return null;
		}

		return _react2.default.createElement(
			'div',
			{ style: { position: 'relative' } },
			_react2.default.createElement(
				'select',
				{ id: 'countrySelection',
					className: 'vx_form-control ' + (0, _aphrodite.css)(STYLES.dropdown),
					value: this.state.selectedCountry,
					onChange: this.handleChangeCountry },
				this.props.supportedCountries.map(function (_ref) {
					var countryCode = _ref.countryCode,
					    countryName = _ref.countryName;
					return _react2.default.createElement(
						'option',
						{ key: countryCode, value: countryCode },
						countryName
					);
				})
			),
			_react2.default.createElement('label', { htmlFor: 'countrySelection', className: 'icon icon-arrow-down-small ' + (0, _aphrodite.css)(STYLES.arrow) })
		);
	}
});

exports.default = CountrySelection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/CountrySelection.js
// module id = 400
// module chunks = 6